import React, { useState, Fragment, useContext, useEffect } from "react";
import { createUser, sendOtp, validateOtp, sendAuthEmail } from "@app/services";
import { AuthContext } from "@app/providers";
import EducatorCommonForm from "./educator-common-form";
import { Toast, Icon, LoginLayout, Button, ProfileUpdtaeDialog } from "@app/components";
import { useLocation } from "@app/utils";
import EducatorSchoolAccount from "./educator-schoolDistrict-signup";
import { PopUpContainer, PopUpSubTitle, PopUpText, PopUpTitle, PopUpWrapper } from "@app/components/success-modal/success-modal-components";
import { ButtonHolder, CenteredText, OTPTimer } from "../sign-up.component";
import { FlexWrapper } from "@app/components/commonStyles";
// import OtpInput from 'react-otp-input';
import Countdown from 'react-countdown'

export default function EducatorSignup() {
  const { navigate } = useLocation();
  const { setUserInfo } = useContext(AuthContext);
  const [showDetailsPage, setShowDetailsPage] = useState<boolean>(false);
  const [buttonText, setButtonText] = useState<string>("Sign Up");
  const [educatorData, setEducatorData] = useState<any>({});
  const [accountType, setAccountType] = useState<string>("");
  const [showToast, setShowToast] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState<boolean>(false);
  const [zipError, setZipError] = useState<boolean>(false);
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(false);
  const [updateRender, setUpdateRender] = useState(false);
  const [render, setRender] = useState<any>([])
  const [state, setState] = useState('');
  const [otpSuccess, setOtpSuccess] = useState(false);
  const [otpFailed, setOtpFailed] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [resendDisabled, setResendDisabled] = useState(true);
  const [UserData, setUserData] = useState<any>()
  const [otpDisable, setOtpDisable] = useState(false)
  const [districtPage, setDistrictPage] = useState(false)
  const [resendOtp, setResendOtp] = useState(false);
  const [failCount, setFailCount] = useState<any>(0);
  const [countryCode, setCountryCode] = useState("+91");
  const [phoneInputErr, showPhoneInputErr] = useState<boolean>()
  const [displayNum, setDisplayNum] = useState<any>()
  const [skipOtpSchoolDis, setSkipOtpSchoolDis] = useState(false)
  const [skipOtpValidate, setSkipOtpValidate] = useState(false)
  function Completed() {
    setResendDisabled(false)
    setOtpDisable(true)
    setState('')

    // setBtnDisabled(state.length !== 4)
  }




  function SendOtp(data: any) {
    if (accountType === "school/district") {
      onSubmit(data)
      setSkipOtpSchoolDis(true)
      return true
    }

    // console.log(countryCode)
    // if(!countryCode){
    //   showPhoneInputErr(true)
    //   return 
    // }
    CountryCOde()
    setOtpDisable(false)
    setResendDisabled(true)
    setUserData(data)
    // var UnformattedNumber = data.phoneNumber || UserData.phoneNumber;
    // UnformattedNumber = UnformattedNumber.replace(/\D+/g, '').replace(`[0-9]`);
    const params: any = {};
    // console.log(countryCode)
    Object.assign(params, {
      sessionToken: 'anonymous',
      userId: 999,
      phoneNumber: "+".concat(countryCode),
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      userType: "educator"
    });
    
    sendAuthEmail(params)
      .then((resp) => {
        const response = resp;
        if (response.sessionToken === "anonymous") {
          onSubmit(data)
          setShowSuccess(false);
          setUpdateRender(false);

        } else {
          setToastMessage({
            type: "error",
          });
          setShowToast(true);
        }
      })
      .catch((err) => {
        console.log(err, "otpError");
      });
    return
  }



  function onSubmit(data: any) {
    if (emailError || phoneError || zipError) return;
    if (data.accountType === "school/district") {
      setButtonText("Continuing...");
      setEducatorData(data);
      localStorage.setItem('firstName', data.firstName)
      localStorage.setItem('lastName', data.lastName)
      localStorage.setItem('phoneNumber', data.phoneNumber)
      localStorage.setItem('email', data.email)
      localStorage.setItem('city', data.city)
      localStorage.setItem('state', data.state.value)
      localStorage.setItem('zip', data.zip)
      localStorage.setItem('ambassador', data.ambassador)
      return setShowDetailsPage(true);
    } else {
      setButtonText("Signing Up...");
      const params: any = {};
      Object.assign(params, {
        userType: "educator",
        firstName: data.firstName,
        lastName: data.lastName,
        phoneNumber: countryCode,
        email: data.email,
        city: data.city,
        state: data.state.value,
        zip: data.zip,
        educatorLicenseType: accountType,
        password: data.password,
        confirmPassword: data.confirmPassword,
        kazooAmbassador: data.ambassador ? 1 : 0,
        termsOfService: 1,
      });

      createUser(params)
        .then((resp) => {
          const response = resp;
          if (response._responseStatus) {
            setButtonText("Sign Up");
            localStorage.setItem("teacherData", JSON.stringify(response));
            localStorage.setItem("accountType", JSON.stringify(accountType));
            localStorage.setItem("paymentUser", JSON.stringify({ ...params, userId: response.userId }));
            localStorage.setItem("paymentSource", "signUp");
            localStorage.setItem("parentDataSource", JSON.stringify(response));
            setShowSuccess(true);
            // setUserInfo(response);
            // setShowSuccessPopUp(true);
            // navigate('/otp-verification')
          } else {
            setButtonText("Sign Up");
            setToastMessage({
              type: "error",
              message: response.msg,
            });
            setShowToast(true);
          }
        })
        .catch((err) => {
          setButtonText("SignUP");
          console.log(err, "signupError");
          setToastMessage({
            type: "error",
            message: `Something went wrong, Please try again`,
          });
          setShowToast(true);
        });
    }
  }

  function onCancel() {
    setShowSuccessPopUp(false)
    navigate('/sign-in')
  }

  const handleChange = (value: any) => {
    setState(value);
  }
  function onSuccessCancel() {
    navigate("/payment")
  }

  function FailureCancel(UserData: any) {
    setShowSuccess(false)
    setOtpFailed(false)

  }

  function ValidateOtp() {

    // var NumberPattern = UserData.phoneNumber;
    // NumberPattern = NumberPattern.replace(/\D+/g, '')
    //   .replace(`[0-9]`);
    const params: any = {};
    Object.assign(params, {
      sessionToken: 'anonymous',
      userId: 999,
      phoneNumber: "+".concat(countryCode),
      otpCode: state
    });
    validateOtp(params)
      .then((resp) => {
        const response = resp;
        if (response._responseStatus === 1) {
          // setCountryCode("+91")
          onSubmit(UserData)
          setOtpSuccess(true)
        } else {
          setOtpFailed(true)
          setFailCount(failCount + 1)
          if (failCount > 2)
            console.log()
        }
      })
      .catch((err) => {
        console.log(err, "OtpValidation Error");
      });
  }

  function ReCheck() {
    setShowSuccess(false)
    setOtpFailed(false)
    setState('')
    if (failCount > 2) {
      setFailCount(0)
    }
    // setCountryCode('')

  }
  function OtpCancel() {
    setOtpFailed(false)
    setState('')
    if (failCount > 2) {
      setFailCount(0)
    }
  }

  function CountryCOde() {
    if (countryCode.startsWith('9')) {
      let code: any = countryCode.replace(/(\d{2})/, '$1-')
      setDisplayNum("+".concat(code))
    } else if (countryCode.startsWith('1')) {
      let code1: any = countryCode.replace(/(\d{1})/, '$1-')
      setDisplayNum("+".concat(code1))
    }
  }

  if (!showSuccess) {
    return (
      <Fragment>
        {!showDetailsPage && (
          <EducatorCommonForm
            submitData={onSubmit}
            buttonText={buttonText}
            updateButtonText={setButtonText}
            accountType={accountType}
            updateAccountType={setAccountType}
            setEmailError={setEmailError}
            zipError={zipError}
            setZipError={setZipError}
            phoneError={phoneError}
            setPhoneError={setPhoneError}
            SendData={SendOtp}
            ValidateOtp={ValidateOtp}
            UserData={UserData}
            failCount={failCount}
            countryCodeNum={setCountryCode}
            countryCode={countryCode}
          // showPhoneInputErr={phoneInputErr}
          />
        )}
        {showDetailsPage && accountType === "school/district" && (
          <EducatorSchoolAccount educatorData={educatorData} />
        )}


        <Toast
          message={toastMessage.message}
          showToast={showToast}
          type={toastMessage.type}
          onClose={() => setShowToast(false)}
        />
      </Fragment>
    );
  }
  else {
    
    return <>
        <PopUpWrapper>
          <PopUpContainer>
            <Icon name="signsuccess" />
            <span className="close-icon" onClick={() => navigate(accountType === "teacherAccount" ? "/sign-in/educator" : '' ||
              accountType === "schoolLicenseCode" ? "/sign-in/educator" : '' ||
                accountType === "school/district" ? "/sign-in/educator" : '')}>
              <Icon name="close" />
            </span>
            <PopUpTitle>Sign up completed!</PopUpTitle>
            <PopUpSubTitle>
              Thank you for signing up kazoobadoo
            </PopUpSubTitle>
            <PopUpText>Please check your inbox and click on the verification link to verify your account</PopUpText>
          </PopUpContainer>
        </PopUpWrapper>
    </>

  }
}
